import { FEATURE_FLAGS } from '../constants';
import featureFlags from '../helpers/featureFlags';
import { useGetUsersMe } from './queries/usersMeQueries';

export const useGetRfisMaintenanceMode = () => {
  const { data: usersMe } = useGetUsersMe();
  const webFF = featureFlags.get(FEATURE_FLAGS.MAINTENANCE_MODE);
  const backendFF = !!usersMe?.maintenanceEndDate;

  const isMaintenanceMode = (() => {
    switch (webFF) {
      case 'OFF':
        return false;
      case 'ON':
        return true;
      case 'Backend':
        return !!backendFF;
      default:
        return false;
    }
  })();

  return isMaintenanceMode;
};
